/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdPositionEnum {
    HOME_MATCH = 'HOME_MATCH',
    LEAGUE_MATCH_MATCH = 'LEAGUE_MATCH_MATCH',
    MATCH_HISTORY_BOTTOM = 'MATCH_HISTORY_BOTTOM',
    MATCH_FEED = 'MATCH_FEED',
    USER_FEED = 'USER_FEED',
    TEAM_OF_THE_WEEK = 'TEAM_OF_THE_WEEK',
    STANDINGS = 'STANDINGS',
    NEWS_ADS = 'NEWS_ADS',
    ADMOB_PLACEHOLDER = 'ADMOB_PLACEHOLDER',
    HOME_MATCH_DOUBLE = 'HOME_MATCH_DOUBLE',
    MATCH_INFO_BOTTOM = 'MATCH_INFO_BOTTOM',
    MATCH_INFO_TOP = 'MATCH_INFO_TOP',
    MATCH_LINEUP = 'MATCH_LINEUP',
    MATCH_H2H = 'MATCH_H2H',
    TEAM_STATS = 'TEAM_STATS',
    TEAM_MATCHES = 'TEAM_MATCHES',
    LEAGUE_STATS_TEAM = 'LEAGUE_STATS_TEAM',
    LEAGUE_STATS_PLAYER = 'LEAGUE_STATS_PLAYER',
    LEAGUE_SCREEN_BANNER = 'LEAGUE_SCREEN_BANNER',
    TEAM_SCREEN_BANNER = 'TEAM_SCREEN_BANNER',
    HOME_SCREEN_BANNER = 'HOME_SCREEN_BANNER',
    NEWS_SCREEN_BANNER = 'NEWS_SCREEN_BANNER',
    LEAGUE_LIST_SCREEN_BANNER = 'LEAGUE_LIST_SCREEN_BANNER',
    MATCH_SCREEN_BANNER = 'MATCH_SCREEN_BANNER',
    SPLASH_SCREEN = 'SPLASH_SCREEN',
    MATCH_LINEUP_TOP = 'MATCH_LINEUP_TOP',
    MATCH_HISTORY_TOP = 'MATCH_HISTORY_TOP',
    MATCH_H2H_TOP = 'MATCH_H2H_TOP',
    MATCH_TABLE = 'MATCH_TABLE',
    LEAGUE_TABLE = 'LEAGUE_TABLE',
    TEAM_TABLE = 'TEAM_TABLE',
    PLAYER_OVERVIEW = 'PLAYER_OVERVIEW',
    PLAYER_SCREEN_BANNER = 'PLAYER_SCREEN_BANNER',
    MATCH_MOTM = 'MATCH_MOTM',
    TEAM_STATS_TOP = 'TEAM_STATS_TOP',
    TEAM_INFO = 'TEAM_INFO',
    TEAM_SQAD = 'TEAM_SQAD',
    LEAGUE_TOTW = 'LEAGUE_TOTW',
    FANTA_HOME = 'FANTA_HOME',
    FANTA_MATCH_DAY = 'FANTA_MATCH_DAY',
    FANTA_TEAM = 'FANTA_TEAM',
    FANTA_RANKING = 'FANTA_RANKING',
    FANTA_HOME_SCREEN_BANNER = 'FANTA_HOME_SCREEN_BANNER',
    FANTA_TEAM_SCREEN_BANNER = 'FANTA_TEAM_SCREEN_BANNER',
    FANTA_RANKING_SCREEN_BANNER = 'FANTA_RANKING_SCREEN_BANNER',
    SEARCH = 'SEARCH',
}
